export default __webpack_public_path__ + "static/clients01-d92e2e37a444f09b18d54202d11770fb.svg";